import { configureStore, createSlice } from '@reduxjs/toolkit' 
// 콘피규어는 등록. 사일러스는 만드는 것


// 장바구니 회원 이름
let user = createSlice({
    name : 'user',
    initialState : { name : '별' },
})



// 장바구니 state
let cart = createSlice({
    name : 'cart',
    initialState : [ 

    // 원래 안에 들어있는 상품들
    {id: 0 , code : "M3122PKT15OWT" , imgUrl:'top_seller1.jpg', name : '말본 골프 스웨터 OFF WHITE', count : 1}, 
    {id: 1 , code : "M3122PKT17CRM" , imgUrl:'top_seller2.jpg', name : '우들리 카라 스웨터 CREAM', count : 1},
    {id: 2 , code : "M3222PTS34GRN" , imgUrl:'top_seller3.jpg', name : '버킷 포인트 폴로 티셔츠 GREEN', count : 1}
    ],

    // 함수
    reducers : {

    // 장바구니에서 수량 더할 때
    addCount(state, action) {
        let num = state.findIndex((a) => {
        return a.code === action.payload;
    });
        console.log(num);
        state[num].count++;
    },

    // 장바구니에서 수량 뺄 때 - 0 일 때 경고창
    decreaseCount(state, action) {
        let num = state.findIndex((a) => {
        return a.code === action.payload;
        });
        console.log(num);
        if (state[num].count > 0) {
        state[num].count--;
        } else if (state[num].count === 0) {
        alert("상품이 더 이상 없습니다.");
        }
    },

    // 서브 페이지에서 담기 하면 담아지는데, 이미 있으면 수량만 올라감.
    addItem(state, action) {
        let num = state.findIndex((a) => a.code === action.payload.code);
        if (num !== -1) {
        state[num].count++;
        } else {
        state.push(action.payload);
        }
    },

    // 장바구니에서 상품 삭제. 
    deleteItem(state, action) {
        let num = state.findIndex((a) => {
        return a.code === action.payload;
        });
        state.splice(num, 1);
        // 내가 누른 값이 있는 인덱스부터 1개를 지우겠다.
    },

    // 이름순 정렬
    sortName(state, action) {
        state.sort((a, b) => (a.name > b.name ? 1 : -1));
    }
    }
})

// addCount(1)
// 카트의 액션으로 함수 내보내기.
export let { addCount, decreaseCount, addItem, deleteItem, sortName } = cart.actions;




// 스테이트 내보내야 쓸 수 있음. 콘피규어로 등록
export default configureStore({
    reducer: {
    user: user.reducer,
    cart: cart.reducer,
    },
});
